import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import { useInputId } from './hooks';

function FormPhoneNumber({
  id: defaultId,
  icon: Icon,
  label,
  name,
  onChange,
  onSetFieldValue,
  value,
  error,
  required,
  disabled,
  ...props
}) {
  const [id] = useInputId(defaultId);
  const handleChange = ({ target }) => {
    if (typeof onChange === 'function') {
      onChange((state) => ({
        ...state,
        [name]: target.value,
      }));
    }
    if (typeof onSetFieldValue === 'function') {
      onSetFieldValue(name, target.value);
    }
  };
  const showIcon = Icon || error;
  const isError = !!error;

  return (
    <div className="flex flex-col">
      <label htmlFor={id} className="block font-medium text-gray-500 mb-2">
        <span>{label}</span>
        {required && <span className="ml-1 font-light text-red-500">*</span>}
      </label>
      <div
        className={cn(
          'relative border rounded-2xl p-3 shadow-sm focus-within:ring-1 z-[1]',
          isError
            ? 'border-red-300 focus-within:ring-red-500 focus-within:border-red-500 animate-wiggle'
            : 'border-gray-300 focus-within:ring-primary-600 focus-within:border-primary-600',
          disabled ? 'bg-gray-100' : 'bg-white'
        )}
      >
        <InputMask
          mask="+673 999 9999"
          id={id}
          name="name"
          className={cn(
            'block w-full border-0 p-0 text-gray-900 placeholder-gray-300 focus:ring-0 text-base',
            'focus:outline-none',
            showIcon ? 'pr-10' : ''
          )}
          onChange={handleChange}
          value={value}
          {...props}
        />
      </div>
    </div>
  );
}
FormPhoneNumber.defaultProps = {
  id: '',
  icon: false,
  type: 'text',
  error: null,
  disabled: false,
  required: false,
  onChange: false,
  onSetFieldValue: false,
};

FormPhoneNumber.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.bool]),
  error: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  onChange: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  onSetFieldValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
};

export default React.memo(FormPhoneNumber);
